import { CACHE_TAG_BUSINESS_INFO } from '../cacheTagTypes'
import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getBusinessInfo: build.query({
      query: () => ({
        url: '/api/v1/core/business',
      }),
      providesTags: [CACHE_TAG_BUSINESS_INFO],
    }),
  }),
})
export const { useLazyGetBusinessInfoQuery } = extendedApi

export const getBusinessInfoSlice = extendedApi.endpoints.getBusinessInfo.select(undefined)
